export default __webpack_public_path__ + "static/media/bar_rinott.b7ae5f56.jpeg";